<template>
  <div :class="$style.venueImageSection">
    <div :class="[
      $style.venueImageContainer,
      { [$style.clickable]: showControls },
    ]" @click="openModal">
      <img v-if="venueImage" :src="venueImage" :alt="venueName" :class="$style.venueImage" />
      <div v-else :class="$style.noVenueImage">
        <span>🏢</span>
        <p>공연장 이미지</p>
      </div>

      <!-- 편집 아이콘 오버레이 -->
      <div v-if="showControls" :class="$style.editOverlay">
        <span :class="$style.editIcon">📷</span>
      </div>
    </div>

    <!-- 공연장 이미지 편집 모달 -->
    <VenueImageModal :is-visible="isModalVisible" :current-image="venueImage" :venue-name="venueName"
      @close="closeModal" @image-updated="handleImageUpdated" @image-removed="handleImageRemoved" />
  </div>
</template>

<script>
import VenueImageModal from "./modal/VenueImageModal.vue";

export default {
  name: "VenueImageUploader",
  components: {
    VenueImageModal,
  },
  props: {
    venueName: {
      type: String,
      required: true,
    },
    venueImage: {
      type: String,
      default: null,
    },
    showControls: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["image-updated", "image-removed"],
  data() {
    return {
      isModalVisible: false,
    };
  },
  methods: {
    openModal() {
      if (this.showControls) {
        this.isModalVisible = true;
      }
    },

    closeModal() {
      this.isModalVisible = false;
    },

    handleImageUpdated(url) {
      this.$emit("image-updated", url);
      // console.log(`Venue image updated: ${url}`);
    },

    handleImageRemoved() {
      this.$emit("image-removed");
      // console.log("Venue image removed");
    },
  },
};
</script>

<style module>
/* ========================================
   Medium: 481px ~ (기본 스타일, 최대 1024px)
   ======================================== */
.venueImageContainer {
  width: 100%;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  position: relative;
  transition: all 0.2s ease;
}

.venueImageContainer.clickable {
  cursor: pointer;
}

.venueImageContainer.clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.venueImageContainer.clickable:hover .editOverlay {
  opacity: 1;
}

.venueImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  z-index: 1;
}

.noVenueImage {
  width: 300px;
  height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  position: relative;
  z-index: 1;
}

.noVenueImage span {
  font-size: 36px;
  margin-bottom: 8px;
}

.noVenueImage p {
  margin: 0;
  font-size: 12px;
  font-family: "NanumSquareRoundR", sans-serif;
}

/* 편집 오버레이 */
.editOverlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  border-radius: 10px;
  z-index: 2;
}

.editIcon {
  font-size: 24px;
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

/* ========================================
   Small (~480px)
   ======================================== */
@media screen and (max-width: 480px) {
  .noVenueImage span {
    font-size: 28px;
  }

  .editIcon {
    font-size: 20px;
  }
}
</style>
